import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastService } from '../../../share/services/toast.service';
import { version } from '../../../share/version';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  toastService = inject(ToastService);

  public readonly version: string;

  constructor() {
    this.version = version;
  }
}
